import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ModelIntegrationCode } from '@/features/modelIntegrationCodes/types/modelIntegrationCode.type'
import { useQuery } from '@tanstack/react-query'

export const useModelIntegrationCode = (id: string) => {
  const privateAxios = usePrivateAxios()

  return useQuery({
    queryKey: ['modelIntegrationCodes', 'show', id],
    enabled: !!id,
    queryFn: () => privateAxios.get(`/equipment_models/${id}`),
    select: (response: { data: { data: ModelIntegrationCode } }) => response?.data?.data,
  })
}
